// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1koko","container":"styles_container__Deosa","title":"styles_title__3qoEh","wrapper":"styles_wrapper__8eDud","answer":"styles_answer__384L1"};